import React, { PureComponent } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './ListCard.scss';

class ListCard extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    iconName: PropTypes.string,
    title: PropTypes.string,
    list: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        description: PropTypes.string
      })
    )
  };

  render() {
    const { className, iconName, title, list } = this.props;

    return (
      <div
        data-test="list-card-container"
        className={classnames('list_card', className)}
      >
        <header className="list_card__header">
          <span className="list_card__icon">
            <FontAwesomeIcon icon={['fal', iconName]} />
          </span>
          <span data-test="card-title">{title}</span>
        </header>
        {list && (
          <div className="list_card__content">
            {list.map((item, key) => (
              <div
                data-test="card-item"
                key={item.id}
                className="list_card__item"
              >
                <span className="list_card__step_number">{key + 1}</span>
                <span data-test="card-item-text">{item.description}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default ListCard;
